import { css } from 'styled-components';

import {
  responsiveBreakPoints,
  SHARED_TABLET_CONTENT_WIDTH,
} from '../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../colors-v2';

export const BlogEditorDefaultStyles = css`
  .title-template-wrapper {
    width: 720px;
  }
  .blog-editor-container {
    width: 1072px;
    border-radius: 0 0 8px 8px;
    margin: 0 auto;
    margin-left: calc((100vw - ${SHARED_TABLET_CONTENT_WIDTH}px) / 2 - 290px);
  }

  .body-topbar {
    background: ${colorsV2.white100};
    border-radius: 8px 8px 0 0;
    margin: 0 auto;
    align-items: center;
    padding: 12px 24px;
    box-shadow: inset 0 -1px 0 ${colorsV2.gray10};
  }

  .blog-editor-sidebar {
    &-left,
    &-right {
      top: 84px;
    }
  }
`;

export const EditorDailyNewStyles = css`
  .title-template-wrapper {
    width: 576px;
  }
  .blog-editor-container {
    width: 920px;
    grid-template-columns: 304px 576px 100px;
    margin-left: calc((100vw - 576px) / 2 - 284px);
  }
  .dol-editor {
    > * {
      font-family: Inter, sans-serif;
    }
  }
`;

export const EditorDailyNewsUserViewStyles = css`
  && {
    .blog-editor-container {
      border-radius: 0 0 8px 8px;
      margin: 0 auto;
      width: 100%;
      margin-left: auto;
      &.read-only {
        .dol-editor {
          padding: 0 24px;

          background-color: transparent;
        }
      }
    }

    @media ${responsiveBreakPoints['above-540']} {
      .title-template-wrapper {
        width: 576px;
      }
      .blog-editor-container {
        width: 576px;
      }
    }
  }
`;
